import CloseIcon from 'assets/icons/close.svg';
import WhiteCloseIcon from 'assets/icons/close-white.svg';

interface ModalHeaderProps {
  title: string;
  description: string;
  onClose: () => void;
}

const ModalHeader = ({ title, description, onClose }: ModalHeaderProps) => {
  return (
    <div className='flex items-start justify-between py-6 px-8'>
      <div className='flex flex-col gap-2'>
        <h2 className='text-[28px] font-semibold leading-[34px] dark:text-white'>
          {title}
        </h2>
        <p className='text-base text-gray-850 dark:text-gray-300 leading-[24px]'>
          {description}
        </p>
      </div>
      <picture>
        <source
          srcSet={WhiteCloseIcon}
          media='(prefers-color-scheme: dark)'
        />
        <img
          className='cursor-pointer'
          src={CloseIcon}
          alt=''
          onClick={onClose}
        />
      </picture>
    </div>
  );
};

export default ModalHeader; 